import React from 'react';
import {
  SidebarContainer,
  Icon,
  CloseIcon,
  SidebarWrapper,
  SidebarMenu,
  SidebarLink,
  SidebarExternalLink,
  SidebarRoute,
  SidebarExternalRoute,
  SideBtnWrap
} from './SidebarElements';

const Sidebar = ({ isopen, toggle }) => {
  const handleCloseClick = (e) => {
    e.stopPropagation();
    toggle();
  };

  const stopPropagation = (e) => {
    e.stopPropagation();
  };

  return (
    <SidebarContainer
      style= {{
        opacity: isopen ? '100%' : '0',
        top: isopen ? '0' : '-100%',
        pointerEvents: isopen ? 'auto' : 'none'
      }}
      onClick={toggle}>
      <Icon onClick={handleCloseClick}>
        <CloseIcon />
      </Icon>
      <SidebarWrapper onClick={stopPropagation}>
        <SidebarMenu>
          <SidebarLink
            to='/'
            onClick={toggle}
            smooth='true'
            duration={500}
            spy='true'
            exact='true'
            offset={-80}
          >
            Home
          </SidebarLink>
          <SidebarLink
            to='/shop'
            onClick={toggle}
            smooth='true'
            duration={500}
            spy='true'
            exact='true'
            offset={-80}
          >
            Shop
          </SidebarLink>
          <SidebarLink
            to='/flyfishing'
            onClick={toggle}
            smooth='true'
            duration={500}
            spy='true'
            exact='true'
            offset={-80}
          >
            Fly Fishing
          </SidebarLink>
          <SidebarLink
            to='/'
            onClick={toggle}
            smooth='true'
            duration={500}
            spy='true'
            exact='true'
            offset={-80}
          >
            Our Story
          </SidebarLink>
        </SidebarMenu>
        {/* <SideBtnWrap>
          <SidebarExternalRoute href='https://app.tumbledelivery.com/'>Login</SidebarExternalRoute>
        </SideBtnWrap> */}
      </SidebarWrapper>
    </SidebarContainer>
  );
};

export default Sidebar;